import type { ReadonlyDeep } from '../../types/readonly-deep';
import { FactTrajectoryPointEntity, FactTrajectoryEntity } from '../entities';
import type { TFactTrajectory, TFactTrajectoryPoint } from '../model';

const mapFactTrajectoryPoint = (rawPoint: ReadonlyDeep<TFactTrajectoryPoint>): FactTrajectoryPointEntity => {
  return new FactTrajectoryPointEntity(rawPoint as TFactTrajectoryPoint);
};

export const mapFactTrajectory = (rawTrajectory: ReadonlyDeep<TFactTrajectory>): FactTrajectoryEntity => {
  const mappedPoints = rawTrajectory.points.map(mapFactTrajectoryPoint);

  return new FactTrajectoryEntity(mappedPoints);
};
